import { Table } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import isEmpty from 'lodash/isEmpty';
import React, { ReactElement } from 'react';
import { CompanyDeal } from '../../../../models/CompanyDeal';
import NoResults from '../../../NoResults';
import { TABLE_CONFIG } from './CompanyDealsWidget.logic';
import styles from './CompanyDealsWidget.module.scss';

const cx = classNames.bind(styles);

interface CompanyDealsWidgetContentProps {
  deals: CompanyDeal[];
}

const getKey = (row) => row.id;

const CompanyDealsWidgetContent = ({ deals }: CompanyDealsWidgetContentProps): ReactElement | null => {
  return isEmpty(deals) ? (
    <NoResults title="No deals found" infoText="Try looking for deals with a different set of filters or status." />
  ) : (
    <div className={classNames(cx('content'), 'to-translate')}>
      <Table data={deals} tableViewConfig={TABLE_CONFIG} getKey={getKey} autoLayout />
    </div>
  );
};

export default CompanyDealsWidgetContent;
